import { toastController } from '@modus/ionic-vue'

// moved to backend
export function handleBridgeError(error) {
  // if(!error.config) {
  //   return Promise.reject(error)
  // }

  // const config = error.config
  // let message = 'Failed to connect to bridge'

  // if(config.method === 'patch') {
  //   message = 'Update failed'
  // }
  
  // if(config.url.startsWith('bridges/')) {
  //   toastController.create({
  //     message,
  //     duration: 3000
  //   })
  //   .then(toast => toast.present())
  // }

  return Promise.reject(error)
}